<template>
  <el-dialog
    class="customDialogForm customDialogForm--compact"
    :visible="dialogVisible"
    width="500px"
    :before-close="close"
    :close-on-click-modal="false"
    :title="title"
  >
    <div class="dialog-intro">
      为了保证账户安全，新密码不能与旧密码相同，且建议使用更复杂的组合。
    </div>
    <el-form ref="versionform" :rules="rules" :model="data">
      <el-form-item
        prop="password"
        label="旧密码"
        :label-width="formLabelWidth"
      >
        <el-input
          type="password"
          v-model="data.password"
          autocomplete="off"
        ></el-input>
      </el-form-item>
      <el-form-item
        prop="newPassword"
        label="新密码"
        :label-width="formLabelWidth"
      >
        <el-input
          type="password"
          v-model="data.newPassword"
          autocomplete="off"
        ></el-input>
      </el-form-item>
      <el-form-item
        prop="newPassword2"
        label="确认密码"
        :label-width="formLabelWidth"
      >
        <el-input
          type="password"
          v-model="data.newPassword2"
          autocomplete="off"
        ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="close">取 消</el-button>
      <el-button
        type="primary"
        @click="submit"
        :loading="Loading"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>
<script>
import { changePassword } from '@/api/user';
import { errorHandle } from '@/utils/error';
export default {
  name: 'ChangePassword',
  props: {
    dialogVisible: Boolean,
    onClose: Function,
    onSuccess: Function
  },
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else if (value === this.data.password) {
        callback(new Error('新密码与输入旧密码一致, 无需修改'));
      } else {
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.data.newPassword) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      rules: {
        password: [
          { required: true, message: '请输入旧密码', trigger: 'blur' },
          { min: 6, message: '密码长度最小6位', trigger: 'blur' },
          { max: 255, message: '密码长度最大255位', trigger: 'blur' }
        ],
        newPassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 6, message: '密码长度最小6位', trigger: 'blur' },
          { max: 255, message: '密码长度最大255位', trigger: 'blur' },
          { validator: validatePass, trigger: 'blur' }
        ],
        newPassword2: [
          { required: true, message: '请再次输入新密码', trigger: 'blur' },
          { min: 6, message: '密码长度最小6位', trigger: 'blur' },
          { max: 255, message: '密码长度最大255位', trigger: 'blur' },
          { validator: validatePass2, trigger: 'blur' }
        ]
      },
      data: {},
      title: '修改登录密码',
      formLabelWidth: '80px',
      Loading: false
    };
  },
  created() {},
  methods: {
    submit() {
      this.Loading = true;
      this.$refs.versionform.validate(valid => {
        if (valid) {
          changePassword({
            password: this.data.password,
            newPassword: this.data.newPassword
          })
            .then(res => {
              this.Loading = false;
              this.onSuccess && this.onSuccess();
            })
            .catch(err => {
              this.Loading = false;
              errorHandle(err);
            });
        } else {
          this.Loading = false;
        }
      });
    },
    close() {
      this.$refs.versionform.resetFields();
      this.onClose && this.onClose();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Header/components/changePassword.vue